import { useState, useEffect } from 'react'
import { api } from '../lib/api'
import toast from 'react-hot-toast'

export default function InviteAccept({ token }) {
  const [state, setState] = useState('loading') // loading | valid | invalid | done
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    api.validateInvite(token)
      .then(d => { setEmail(d.email); setState('valid') })
      .catch(err => { setError(err.message); setState('invalid') })
  }, [token])

  async function submit() {
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return }
    if (password !== confirm) { toast.error('Passwords do not match'); return }
    setSaving(true)
    try {
      await api.acceptInvite(token, password)
      setState('done')
    } catch (err) { toast.error(err.message) }
    setSaving(false)
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>AdOps Management</h1>
          <p>{state === 'valid' ? 'Set your password to activate your account' : 'Account Invitation'}</p>
        </div>

        {state === 'loading' && (
          <div style={{textAlign:'center',padding:'30px 0'}}>
            <div style={{width:28,height:28,border:'3px solid var(--border2)',borderTopColor:'var(--accent)',borderRadius:'50%',animation:'spin 0.7s linear infinite',margin:'0 auto'}}/>
          </div>
        )}

        {state === 'invalid' && (
          <div style={{textAlign:'center',padding:'20px 0'}}>
            <div style={{fontSize:36,marginBottom:12}}>⚠️</div>
            <div style={{fontSize:14,fontWeight:600,color:'var(--red)',marginBottom:6}}>Invalid Invite</div>
            <div style={{fontSize:13,color:'var(--text2)'}}>{error}</div>
            <a href="/" style={{display:'inline-block',marginTop:16,fontSize:13,color:'var(--accent)',textDecoration:'none'}}>Go to login →</a>
          </div>
        )}

        {state === 'done' && (
          <div style={{textAlign:'center',padding:'20px 0'}}>
            <div style={{fontSize:36,marginBottom:12}}>✅</div>
            <div style={{fontSize:14,fontWeight:600,color:'var(--accent3)',marginBottom:6}}>Account Activated!</div>
            <div style={{fontSize:13,color:'var(--text2)',marginBottom:16}}>You can now log in with your email and new password.</div>
            <a href="/" className="btn btn-primary" style={{textDecoration:'none'}}>Go to Login</a>
          </div>
        )}

        {state === 'valid' && (
          <div>
            <div className="form-group">
              <label>Email</label>
              <input value={email} disabled className="input-readonly" />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="At least 6 characters" onKeyDown={e=>e.key==='Enter'&&submit()} />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)}
                placeholder="Re-enter password" onKeyDown={e=>e.key==='Enter'&&submit()} />
            </div>
            <button className="btn btn-primary login-btn" onClick={submit} disabled={saving}>
              {saving ? 'Activating...' : 'Set Password & Activate'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
